import React from 'react';
import ContactUsForm from '../../common/components/Forms/ContactUsForm';
import ornament from '../../assets/img/HomePage/contact-us-ornament.png';

function ContactUsSection() {
  return (
    <section className="contact-us-section" id="contact-us">
      <div className="contact-us-section__inner">
        <h2 className="contact-us-section__title">Contact Us</h2>
        <ContactUsForm />
      </div>
      <div className="contact-us-section__ornament">
        <img src={ornament} alt="arrows" className="contact-us-section__ornament-img" />
      </div>
    </section>
  );
}

export default ContactUsSection;
